<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="10.25"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M12 17.5L7.23686 8.425L16.7631 8.425L12 17.5Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'SingleSelect' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
